import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const BreadcrumbLink = styled(Link)`
  font-family: ${(props) => (props.font ? props.font : 'Bogle')};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${(props) => (props.color ? props.color : '#6d6e71')};

  &:visited {
    color: ${(props) => (props.color ? props.color : '#6d6e71')};
  }

  &:focus {
    color: ${(props) => (props.color ? props.color : '#6d6e71')};
  }

  &:hover {
    color: ${(props) => (props.hoverColor ? props.hoverColor : '#0071ce')};
    cursor: ${(props) => (props.hoverCursor ? props.hoverCursor : '')};
    text-decoration: none;
  }
`

export const Container = styled.div`
  background-color: #ffffff;
  padding: 2px 8px;
  border-radius: 10px;
  display: flex;
  margin: ${({ margin }) => margin || 'inherit'};
  min-height: 46px;
  display: flex;
  align-items: center;
`

export const BackArrow = styled.img`
  height: 16px;
  padding: 0 4px;
  margin-top: 2px;
`
